import InitApi from "api/InitApi";
import { fetchConfig } from "utils";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

const useGetException = (id, enabled = false) => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.get(`/reported-exceptions/${id}`);
		return response?.data;
	};

	return useQuery(["exception", id], () => fetch(), {
		...fetchConfig,
		enabled: Boolean(id) && enabled,
	});
};

export default useGetException;
